import { useMutation } from "@apollo/client";
import {
  TOGGLE_GENERATION_TEMPLATE_FAVORITE,
  GET_GENERATION_TEMPLATES,
} from "../gql";

interface UseToggleGenerationTemplateFavoriteResult {
  toggleFavorite: (agentId: string) => Promise<boolean>;
  loading: boolean;
  error: Error | null;
}

export function useToggleGenerationTemplateFavorite(
  organizationId: string,
): UseToggleGenerationTemplateFavoriteResult {
  const [mutate, { loading, error }] = useMutation<{
    toggleTemplateFavorite: { boolean: boolean };
  }>(TOGGLE_GENERATION_TEMPLATE_FAVORITE, {
    refetchQueries: [
      {
        query: GET_GENERATION_TEMPLATES,
        variables: { organizationId },
      },
    ],
  });

  const toggleFavorite = async (agentId: string): Promise<boolean> => {
    const result = await mutate({
      variables: { agentId },
    });

    if (result.data?.toggleTemplateFavorite?.boolean === undefined) {
      throw new Error("Failed to toggle favorite");
    }

    return result.data.toggleTemplateFavorite.boolean;
  };

  return {
    toggleFavorite,
    loading,
    error: error || null,
  };
}
